import { render, staticRenderFns } from "./DocumentTargetPicker.vue?vue&type=template&id=259f0a86&scoped=true"
import script from "./DocumentTargetPicker.vue?vue&type=script&lang=js"
export * from "./DocumentTargetPicker.vue?vue&type=script&lang=js"
import style0 from "./DocumentTargetPicker.vue?vue&type=style&index=0&id=259f0a86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259f0a86",
  null
  
)

export default component.exports